import { NgModule } from '@angular/core';
import { SharedModule } from '../shared';
import { SitesListComponent } from './sites-list.component';
import { SiteCardComponent } from './site-card.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        SharedModule,
        ReactiveFormsModule
    ],
    exports: [
        SitesListComponent,
        SiteCardComponent,
    ],
    declarations: [
        SitesListComponent,
        SiteCardComponent,
    ],
})
export class InvestigatorDashboardModule { }
